import {ParsedUrlQuery} from 'querystring';
import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getOriginalParamFromQuery({
  uidInfoList,
  query,
}: {
  uidInfoList: string[];
  query?: ParsedUrlQuery;
}) {
  const [category_uid, subcategory_uid] = uidInfoList;
  const categoryUid = convertQueryInputToSingleElement(category_uid);
  const subcategoryUid = convertQueryInputToSingleElement(subcategory_uid);
  const sortType = convertQueryInputToSingleElement(query?.sort_opt);
  const isComplete = convertQueryInputToSingleElement(query?.is_complete);

  return {
    categoryUid: Number(categoryUid),
    subcategoryUid,
    sortType,
    isComplete: isComplete === 'true' ? true : false,
  };
}
